import { LatestTransaction, NoTransactionsMessage } from '@components'
import NoTransactionsImage from '@images/icons/transactions-icon.png'
import { RecurringPlanStatuses, useGetRecurringPlansQuery } from 'mmfintech-backend-api'
import type { TransactionStatus } from 'mmfintech-backend-api/types'
import { isValidArray } from 'mmfintech-commons'
import { ErrorDisplay, Spinner } from 'mmfintech-portal-commons'

export const Upcoming = () => {
  const {
    data: recurringPlans,
    error: recurringPlansError,
    isLoading: recurringPlansLoading
  } = useGetRecurringPlansQuery({
    recurringPlanStatuses: [RecurringPlanStatuses.ACTIVE],
    size: 3
  })

  return (
    <div>
      {recurringPlansLoading ? (
        <Spinner />
      ) : recurringPlansError ? (
        <ErrorDisplay error={recurringPlansError} />
      ) : isValidArray(recurringPlans?.content) ? (
        <div className='transaction-section-content'>
          {recurringPlans.content.map(data => {
            const { id, recurringPlanName, recurringPlanStatus, nextBillingDate, recurringAmount, currency } = data

            return (
              <LatestTransaction
                data-test={`latest-transaction-${id}`}
                key={id}
                amount={recurringAmount}
                currency={currency}
                direction={'WITHDRAW'}
                reqTime={nextBillingDate}
                status={recurringPlanStatus as unknown as TransactionStatus}
                transactionCategory={'WITHDRAW'}
                trnTypeLocalizationKey={recurringPlanName || 'Recurring Payment'}
              />
            )
          })}
        </div>
      ) : (
        <NoTransactionsMessage iconLink={NoTransactionsImage} showDepositMessage={false} />
      )}
    </div>
  )
}
